const showImageSkin = {
  "image-preview": {
    height: "38px",
    maxWidth: "400px",
  },
  "image-preview-with-link": {
    padding: "6px 0px",
  },
};

export default showImageSkin;
